module.exports = {
    // in the context of analytics tracking, a module is a visible section that serves the same functionality purpose,
    // e.g. a page banner, a product carousel, from HTML's PoV, it's nested under a div whose id is just a pure number
    getModuleIndex: ($element) => {
        let index = -1;

        const $allModules = $('[id]').filter(function() {
            return /^\d+$/.test($(this).attr('id'));
        }).filter(function() {
            return $(this).height() > 1; // filter out modules that only contain CSS or empty markups
        });

        $allModules.each(function(i, e) {
            if ($(e).find($element).length) {
                index = i;
            }
        });

        return index;
    }
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/analytics/analytics-utils.js
 **/